import Vue from 'vue';
import VueRouter from 'vue-router';
import AuthLayout from '../layouts/AuthLayout';
import TheLogin from '../views/TheLogin';
import store from '@/store/index';
import purchase from './purchase';
import warehouse from "./warehouse";
import accounting from './accounting';
import sales from './sales'
import administration from './administration';
import authorize from '../utils/authorize';
import authenticate from '../utils/authenticate';
import fleet from './fleet/index'

Vue.use(VueRouter)
const routes = [
    purchase,
    warehouse,
    accounting,
    sales,
    administration,
    fleet,
    {
        path:"/warehouse-select",
        component: () => import("../views/warehouse/SelectWarehouseView.vue"),
        meta: { requiresAuth: true }
    },
    {
        path:"*",
        component: () => import("../views/PageNotFoundView.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: "/unauthorized",
        component: () => import("../views/Unauthorized.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: "/change-password",
        component: () => import("../views/administration/ChangePasswordView.vue"),
        meta: { requiresGuest: true }
    },
    {
        path: "/",
        name: "Main",
        component: () => import( "../layouts/ProfileLayout.vue" ),
        meta: { requiresAuth: true },
    },
    {
        path: "/auth",
        name: "Auth",
        component: AuthLayout,
        children: [
            {
                path: "login",
                name: "TheLogin",
                component: TheLogin,
                meta: { requiresGuest: true },
            },
        ],
    },
    {
        path: "/profile",
        name: "Profile",
        component: () => import( "../layouts/ProfileLayout.vue" ),
        meta: { requiresAuth: true },
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {

    // protected authenticated routes
    if (to.matched.some((record) => record.meta.requiresAuth)) {

        // redirect to login page if not logged in.
        if(!authenticate(localStorage.getItem("token"))) {
            next("/auth/login");
            return;
        }

        // authorize the permission
        if(to.meta.authorization && !authorize(to.meta.authorization)) {
            next("/unauthorized");
            return;
        }

    }

    // alow public routes to be accessed
    if (to.matched.some((record) => record.meta.requiresGuest)) {

        // prevent logged in users from accessing login page.
        if (store.getters["authentication/loggedIn"] && to.path == "/auth/login") {
            next(false);
            return;
        }

    }

    next();
});

export default router;
